import { UnidMedida, RetAPI, error99 } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid';
import { encode as base64_encode } from 'base-64'

export const UnidadeMedidaService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('UnidMedida/attributes', 'get', { id })
        const attributes: UnidMedida = {
            id: 0,
            description: '',
            fator_conversao: 0,
            dt_cadastro: '',
            id_user_insert: 0,
            name_user_insert: '',
            dt_last_update: '',
            name_user_last_update: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.unid) {

                    attributes.id = resp.data.unid.id
                    attributes.description = resp.data.unid.descricao
                    attributes.fator_conversao = resp.data.unid.fator_conversao
                    attributes.dt_cadastro = resp.data.unid.dt_cadastro
                    attributes.id_user_insert = resp.data.unid.id_user_insert
                    attributes.name_user_insert = resp.data.unid.name_user_insert
                    attributes.dt_last_update = resp.data.unid.dt_last_update
                    attributes.name_user_last_update = resp.data.unid.name_user_last_update

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (unid: UnidMedida): Promise<RetAPI> => {

        let id = ''

        if (unid.id) {
            id = unid.id.toString()
        }

        const resp = await Api('UnidMedida/save', 'post', {

            descricao: unid.description,
            fator_conversao: unid.fator_conversao,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da unidade de medida gravados com sucesso',
                id: resp.data.unid.id,
                data: resp.data,
                dt_cadastro: resp.data.unid.dt_cadastro,
                dt_last_update: resp.data.unid.dt_last_update,
                name_user_insert: resp.data.unid.name_user_insert,
                name_user_last_update: resp.data.unid.name_user_last_update
            }
        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`UnidMedida/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('UnidMedida/filter', 'get', { field, filter_type, filter, id })
        const unidMedida: UnidMedida[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: unidMedida
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.unids.map((item: any) => {
                    return unidMedida.push({

                        id: item.id,
                        description: item.descricao,
                        fator_conversao: item.fator_conversao,
                        dt_cadastro: item.dt_cadastro,

                        id_user_insert: item.id_user_insert,
                        name_user_insert: item.name_user_insert,
                        dt_last_update: item.dt_last_update,
                        name_user_last_update: item.name_user_last_update

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: unidMedida
            }
        }

        return {
            error: false,
            data: unidMedida,
        }

    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('UnidMedida/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const unidMed: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: unidMed
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.unidades.map((item: any) => {
                    return unidMed.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: unidMed
            }
        }

        return {
            error: false,
            data: unidMed,
        }

    }
}